import React, { useState } from 'react'
import Loader from '../../../../../components/Loader';
import Breadcrumb from '../../../../../components/Verifier/breadcrumb/BreadCrumb';
import styles from '../../IssueType.module.css';
import form from './CreateVerifierForm.module.css';
import SlideUpWrapper from '../../../../../components/Transitions/SlideUpWrapper';
import { useLocation, useNavigate } from 'react-router-dom';
const CreateForm = () => {

  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();
  const location=useLocation();

  // console.log(location);
  const data=location?.state?.forms || null;
  const FormSteps = [{
    id: 1,
    text: "Select form  type"
  },
  {
    id: 2,
    text: "Assign Tags"
  },
  {
    id: 3,
    text: "Customize Template"
  },
    // {
    //   id:4,
    //   text:"Assign Tags"
    // }
  ]
  const boxStyle = {
    borderRadius: 'var(--br-5xs)',
    flexWrap: 'wrap',
    padding: '1rem',
    boxSizing: 'border-box',
    border: '1px solid var(--gray-200)',
    margin: '1.5rem 0rem',
    background: 'white'
  }
  const handleCreateForm = () => {
    navigate('../forms/formType')
  }
  return (
    <>

    <div style={{width:"100%"}}>
      <SlideUpWrapper direction='slide-left'>
        <Breadcrumb pos={1} title="Request Verification" category={"verification"} />
        <Loader isOpen={false} />
        <section className={styles.containerBox} style={boxStyle}>
          <h2>
            Choose from Existing Forms
          </h2>
          <div className={form.formContainer}>
            {!data?<h1 className={form.heading}>No form found</h1>:null}
            <span className={form.heading1}>Create a new form</span>
            <div className='StepMainContainer' style={{ marginTop: "1rem" }}>
              {FormSteps.map((i, index) =>
              (<div className='StepContainer' key={index}>
                <div className='VerifierStepsContainer'><div className='VerifierSteps'>{i.id}</div>
                  <span className='VerifierStepcontent'> {i.text} </span></div>
                {i.id == 3 ? null :
                  <div style={{ textAlign: "center" }}><img src='/chevron-right-gray.svg' alt='chevronRightgray.svg' className='right-icon' /></div>}
              </div>)
              )}
            </div>
          </div>
          {loading ? <ShimmerLoader mt="1.5rem" height='3rem' width="9rem" br="10px" /> :
            <button type='submit' className='btn btn-primary' style={{ width: "15%", marginTop: "20px" }} onClick={handleCreateForm}>+ Create Form</button>}
        </section>
      </SlideUpWrapper>
      </div>
    </>
  )
}

export default CreateForm;
